import request from 'Request'

const PatientsService = {
  async get({ appCodes, virtualOfficeId, mrn }) {
    return request.post('/patients/list', { appCodes, virtualOfficeId, mrn })
  }
}

export default PatientsService
